export default "__VITE_ASSET__CLJOxzLm__"